import { render, staticRenderFns } from "./PlanTreatmentBase.vue?vue&type=template&id=81e0a388&scoped=true"
import script from "./PlanTreatmentBase.vue?vue&type=script&lang=ts"
export * from "./PlanTreatmentBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e0a388",
  null
  
)

export default component.exports